import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/lib/utils';

/**
 * The Home group (PART 14 §14.0): Financial Dashboard (the fixed landing
 * page), then the three customizable boards. The four English labels are the
 * ERR-DSH-00-01 fix — both dictionaries carry all four.
 */
const TABS = [
  { to: '/', end: true, key: 'dash.tabFinancial' },
  { to: '/home/sales', end: false, key: 'dash.tabSales' },
  { to: '/home/inventory', end: false, key: 'dash.tabInventory' },
  { to: '/home/cashflow', end: false, key: 'dash.tabCashflow' },
] as const;

export function HomeTabs() {
  const { t } = useTranslation();
  return (
    <nav className="flex flex-wrap gap-1 border-b pb-px" aria-label={t('shell.navHome')}>
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              'rounded-t-md px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground',
              isActive && 'border-b-2 border-primary text-foreground',
            )
          }
        >
          {t(tab.key)}
        </NavLink>
      ))}
    </nav>
  );
}
